import { render, staticRenderFns } from "./Product_cebei_mp4.vue?vue&type=template&id=264a1922&scoped=true&"
import script from "./Product_cebei_mp4.vue?vue&type=script&lang=js&"
export * from "./Product_cebei_mp4.vue?vue&type=script&lang=js&"
import style0 from "./Product_cebei_mp4.vue?vue&type=style&index=0&id=264a1922&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "264a1922",
  null
  
)

export default component.exports